import { render, staticRenderFns } from "./Itemtable.vue?vue&type=template&id=1916a5c4"
import script from "./Itemtable.vue?vue&type=script&lang=js"
export * from "./Itemtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports